import { render } from "./CabinetMenu.vue?vue&type=template&id=c11a6200&lang=pug"
import script from "./CabinetMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./CabinetMenu.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__